import { useState } from 'react';
import { useEventCallback } from '@icp/hooks';
import { loadTableInitState } from './utils';
import { clearSetting, loadFavoriteView, saveSetting, updateFavoriteView } from './settingHandler';

export default function useTableSetting({
  defaultTableState,
  settingKey,
  globalSettingKey,
  settingUrl,
  columnDefs,
}) {
  const [tableState, setTableState] = useState(() =>
    loadTableInitState(settingKey, globalSettingKey, settingUrl, defaultTableState, columnDefs),
  );

  const saveTableState = useEventCallback((newState) => {
    return saveSetting(settingKey, newState);
  });

  const clearTableState = useEventCallback(() => {
    clearSetting(settingKey);
  });

  const loadFavoriteView1 = useEventCallback(() => {
    return loadFavoriteView(settingKey, globalSettingKey, settingUrl);
  });

  const updateFavoriteView1 = useEventCallback((type, params) => {
    return updateFavoriteView(
      { key: settingKey, globalKey: globalSettingKey, url: settingUrl },
      type,
      params,
    );
  });

  return {
    // current state
    tableState,
    setTableState,
    saveTableState,
    clearTableState,
    // saved view list
    loadFavoriteView: settingKey && settingUrl ? loadFavoriteView1 : null,
    updateFavoriteView: settingKey && settingUrl ? updateFavoriteView1 : null,
  };
}
